import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { doRemoveRedirectToSummary } from 'src/actions';

import { useAccountSelector } from './useAccountSelector';

export const useRedirectToSummary = () => {
  const shouldNavigateToSummary = useSelector((state: any) => state.app.redirectToSummary);
  const { account } = useAccountSelector();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (shouldNavigateToSummary) {
      if (account?.accountId) {
        window.gtag('event', 'account', {
          accountId: account?.accountId,
        });
      }

      if (account?.type.isEntity) {
        navigate('/complete-account');

        return;
      }

      navigate('/main/summary');
      dispatch(doRemoveRedirectToSummary());
    }
  }, [shouldNavigateToSummary]);
};
